var Helpers = function(gal) {
    var _this = this,
        _urlRedirectParameter = null;

    function _toggleSideBar(e, time) {
        // window.location.href.indexOf('r=') > -1
        $('#view-header .nav-icon-burger, #view-header-nav, #view-nav-overlay').toggleClass('active');
        // $('#view-header-nav').toggleClass('open');
    }

    function _initBurgerButton() {
        $(document).on('click', '#view-header .nav-icon-burger, #view-nav-overlay', _toggleSideBar);

        // setTimeout(toggleSideBar, 1500);
    }

    function _getQueryParameter(paramName) {
        var searchString = window.location.search.substring(1),
            params = searchString.split("&"),
            i,
            val;

        for (i = 0; i < params.length; i++) {
            val = params[i].split("=");

            if (val[0] == paramName) {
                return val[1];
            }
        }

        return null;
    }

    function _urlHasRedirectParam(url) {
        var has = false;

        if (!_this.urlRedirectParameter) {
            _this.urlRedirectParameter = {
                first: _getQueryParameter('r'),
                second: _getQueryParameter('rs')
            };
        }

        if (_this.urlRedirectParameter.first || _this.urlRedirectParameter.second) {
            has = true;
        }

        return has;
    }

    function _toggleLoader(opacity, time) {
        var $loader = $('#catalog-loader'),
            opacity = typeof opacity !== 'undefined' ? opacity : 0,
            time = typeof time !== 'undefined' ? time : 300;

        $loader.fadeTo(time, opacity);
    }

    function _calculateRowH($obj) {
        var other = $obj.clone(),
            size;

        other.html('a<br>b').hide().appendTo('body');
        size = other.height() / 2;
        other.remove();

        return $obj.height() / size;
    }

    function _renderFix() {
        /*
            If the user is on last page with related brochures and resizes window, related brochrues pictures do not resize.
            Easy fix is to re-render the container with image.
        */
        $('.catalog-border').hide(0).show(0);
    }

    function _interactivePopupCallback() {
        var $popup = $('.popup-interactive-brochure');

        setTimeout(function() {
            $popup.find('.popup-button').addClass("animated tada2");

            setTimeout(function() {
                $popup.remove();
            }, 2500);
        }, 2500);
    }

    function _addInteractiveBrochurePopup() {
        if (typeof gal === 'undefined' ||
            typeof gal.gallery === 'undefined' ||
            typeof gal.gallery.currItem.container === 'undefined' ||
            gal.urlHasRedirectParam(location.href) == true ||
            _checkIfBrochureHasZones() == false ||
            viewConfig.check('hasInteractivePopup') == false
        ) {
            return;
        }

        $(document).on('click', '.popup-interactive-brochure', function(e) {
            $(this).fadeOut(100, function() { $(this).remove(); });
            e.stopPropagation();
            e.preventDefault();
        });

        var $popup = $('.popup-interactive-brochure'),
            $page = $(gal.gallery.currItem.container).find('.page-1');

        // check if view is in single or double mode
        $page = $page.length > 0 ? $page : gal.gallery.currItem.container.parentNode;

        $popup.appendTo($page);
        $popup.addClass('active').fadeTo(300, 1, _interactivePopupCallback);
    }

    function _toggleBtnAnimation(id, animationName, timer) {
        timer = timer || 1000;

        setTimeout(function() {
            $('#' + id + ':not(".animated-end")').addClass(animationName + ' animated');
        }, timer);

        setTimeout(function() {
            $('#' + id).addClass("animated-end");
        }, timer + 850);
    }

    function _checkIfBrochureHasZones() {
        var isInteractive = false;

        if (gal.jsonData.type === ViewConsts.xml) {
            return isInteractive = true;
        }

        $.each(gal.jsonData.originalItems, function(inx, item) {
            if (typeof item.pins !== 'undefined' && item.pins.length > 0) {
                isInteractive = true;
                return false; //break jquery loop
            }
        });

        return isInteractive;
    }

    function _addScript(src, callback) {
        var s = document.createElement('script');

        s.setAttribute('src', src);
        s.onload = callback;

        document.body.appendChild(s);
    }

    _this.toggleSideBar = _toggleSideBar;
    _this.initBurgerButton = _initBurgerButton;
    _this.urlHasRedirectParam = _urlHasRedirectParam;
    _this.toggleLoader = _toggleLoader;
    _this.calculateRowH = _calculateRowH;
    _this.renderFix = _renderFix;
    _this.addInteractiveBrochurePopup = _addInteractiveBrochurePopup;
    _this.toggleBtnAnimation = _toggleBtnAnimation;
    _this.checkIfBrochureHasZones = _checkIfBrochureHasZones;
    _this.addScript = _addScript;
};